import { Component, Inject } from '@angular/core';
import { ListBase } from "../shared/list.base";
import { CrewPermissionsService } from '../../core/crew-permissions.service';

@Component({
    selector: 'crew-applicationusers',
    template: require('../shared/list-view.html')
})
export class ApplicationUsers extends ListBase<Nema.Crew.Model.ApplicationUser>  {
    constructor(
        @Inject("applicationUsers") applicationUsers: Nema.Crew.Model.ApplicationUser[],
        crewPermissionsService: CrewPermissionsService) {

        super(applicationUsers, crewPermissionsService);
    }

    public newEntityState = "app.settings.applicationusers.new";

    public editEntityState = "app.settings.applicationusers.detail";

    public entityName = "User";

    public entityNames = "Users";
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/applicationusers/application-users.component.ts